import { render, staticRenderFns } from "./coupon-module.vue?vue&type=template&id=4c598c9c&scoped=true&lang=pug&"
import script from "./coupon-module.vue?vue&type=script&lang=js&"
export * from "./coupon-module.vue?vue&type=script&lang=js&"
import style0 from "./coupon-module.vue?vue&type=style&index=0&id=4c598c9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c598c9c",
  null
  
)

export default component.exports